export function formatDateToDDMMYYYY(dateString) {
	if (!dateString) return "";
	const [year, month, day] = dateString.split("-");
	return `${day}-${month}-${year}`;
}

export function formatDateToYYYYMMDD(dateString) {
	if (!dateString) return "";
	const [day, month, year] = dateString.split("-");
	return `${year}-${month}-${day}`;
}

export function validRealDate(input_date) {
	if (!input_date) return false;
	const date = new Date(input_date);
	if (Number.isNaN(date.getTime())) {
		return false;
	}
	const day = date.getDate();
	const month = date.getMonth() + 1;
	const year = date.getFullYear();
	return day > 0 && day <= 31 && month > 0 && month <= 12 && year >= 1900 && year <= 9999;
}
